import React, { useCallback, useContext } from 'react';
import { Form } from 'react-final-form';
import { useTranslation } from 'react-i18next';
import PopNotificationsContext from 'providers/PopNotifications/PopNotifications.context';
import { Button } from 'ncoded-component-library';
import FieldPhoneNumber from 'components/FieldPhoneNumber';
import api from 'api';
import { PhoneNumber } from 'models/User';
import CurrentUserContext from 'providers/CurrentUser';
import './AuthPhoneNumber.styles.scss';

type AuthPhoneNumberProps = Record<string, any>;

const AuthPhoneNumber: React.FC<AuthPhoneNumberProps> = (props) => {
  const { t } = useTranslation();
  const { popError, popSuccess } = useContext(PopNotificationsContext);
  const { updateUser } = useContext(CurrentUserContext);

  const handleSubmit = useCallback(
    async ({ phoneNumber }: { phoneNumber: PhoneNumber }) => {
      try {
        const {
          data: { user },
        } = await api.authProcess.changePhoneNumber(phoneNumber);
        updateUser(user);
        popSuccess(t('verification-send-success'));
      } catch (error: any) {
        popError(t('auth-phone-number-error'));
        console.error(error);
      }
    },
    [popError, popSuccess, t, updateUser],
  );

  return (
    <div className="auth-form-wrapper">
      <h2>{t('add-phone-title')}</h2>
      <p>{t('add-phone-paragraph')}</p>
      <Form
        onSubmit={handleSubmit}
        render={({ handleSubmit, submitting, valid }) => {
          return (
            <form
              onSubmit={handleSubmit}
              className="auth-phone-number"
              autoComplete="off"
            >
              <FieldPhoneNumber
                name="phoneNumber"
                placeholder={t('phone-number-placeholder')}
                required
              />
              <p>{t('auth-two-factor-paragraph')}</p>
              <Button type="submit" disabled={submitting || !valid}>
                {t('verify')}
              </Button>
            </form>
          );
        }}
      />
    </div>
  );
};

export default AuthPhoneNumber;
